/**
 * @generated SignedSource<<5b67b952d7fbf38269c8726279afd2d3>>
 * @relayHash e0dad92c418ee2d013c4babcc0b50a13
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0dad92c418ee2d013c4babcc0b50a13

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type De_simulateBetterDocSecondOpinionVisitConfirmationInput = {
  sessionId: number;
};
export type useSimulateBetterDocSecondOpinionVisitConfirmationMutation$variables = {
  input: De_simulateBetterDocSecondOpinionVisitConfirmationInput;
};
export type useSimulateBetterDocSecondOpinionVisitConfirmationMutation$data = {
  readonly de_simulateBetterDocSecondOpinionVisitConfirmation: {
    readonly actionResult: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly caseId: string | null;
      readonly errorReason: string | null;
      readonly exchangeId: number | null;
      readonly httpStatusCode: number | null;
      readonly isSuccessful: boolean;
      readonly sessionId: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useSimulateBetterDocSecondOpinionVisitConfirmationMutation = {
  response: useSimulateBetterDocSecondOpinionVisitConfirmationMutation$data;
  variables: useSimulateBetterDocSecondOpinionVisitConfirmationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "actionResult",
  "args": null,
  "concreteType": "de_BetterDocSessionActionResult",
  "kind": "LinkedField",
  "name": "de_BetterDocSessionActionResult",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccessful",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "httpStatusCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "betterDocState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exchangeId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSimulateBetterDocSecondOpinionVisitConfirmationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_simulateBetterDocSecondOpinionVisitConfirmationPayload",
        "kind": "LinkedField",
        "name": "de_simulateBetterDocSecondOpinionVisitConfirmation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSimulateBetterDocSecondOpinionVisitConfirmationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_simulateBetterDocSecondOpinionVisitConfirmationPayload",
        "kind": "LinkedField",
        "name": "de_simulateBetterDocSecondOpinionVisitConfirmation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e0dad92c418ee2d013c4babcc0b50a13",
    "metadata": {},
    "name": "useSimulateBetterDocSecondOpinionVisitConfirmationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d1808fa059fe07226a70c76ffb1ed815";

export default node;
